import { resetRenewVisaDocumentGroupApi, useGetRenewVisaDocumentGroupInfo } from "@/api/services/main/renew-visa";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { useCacheLocal } from "@/hooks/useCacheLocal";
import { AppRoutes } from "@/routes/config";
import { showError } from "@/utils/error";
import { toast } from "@/utils/toast";
import { Stack, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";

type TConfirmResetRenewVisaDocumentGroupModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ConfirmResetRenewVisaDocumentGroupModal: FC<TConfirmResetRenewVisaDocumentGroupModalProps> = ({ isOpen, onClose }) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { employeeRenewVisaDocumentGroupId } = useParams();
  const { data: renewVisaDocumentGroup } = useGetRenewVisaDocumentGroupInfo();

  const handleResetRenewVisadocumentGroup = async () => {
    if (!employeeRenewVisaDocumentGroupId) return;
    try {
      const rs = await resetRenewVisaDocumentGroupApi(employeeRenewVisaDocumentGroupId);
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RENEW_VISA_DOCUMENTS.FETCH_LIST] });
      navigate(AppRoutes.renewVisa);
      toast.success(rs.message ?? API_SUCCESS_MESSAGE);
      const hiddenRenewVisaRemindPassportModalStorage = useCacheLocal("hidden-renew-visa-remind-passport-modal-storage");
      if (hiddenRenewVisaRemindPassportModalStorage) {
        const storedEmployeeIds = hiddenRenewVisaRemindPassportModalStorage.getJSON() || [];
        const coeEmployeeIds = renewVisaDocumentGroup?.employeeRenewVisaDocuments?.map((doc) => doc.employeeId) || [];
        const updatedEmployeeIds = Array.isArray(storedEmployeeIds) ? storedEmployeeIds?.filter((id: number) => !coeEmployeeIds?.includes(id)) : [];
        hiddenRenewVisaRemindPassportModalStorage.setJSON(updatedEmployeeIds);
      }
    } catch (error) {
      showError(error);
    }
    onClose();
  };

  return (
    <Modal title="申請を削除" isOpen={isOpen} onClose={onClose} onOk={() => handleResetRenewVisadocumentGroup()}>
      <Stack mb={2}>
        <Typography>削除後、申請データがなくなります。よろしいでしょうか？</Typography>
      </Stack>
    </Modal>
  );
};
